export enum IdentityConfirmationTypeEnum {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  M_OBYWATEL= 'M_OBYWATEL',
  NOT_REQUIRED = 'CONFIRMATION_NOT_REQUIRED'
}

